module.exports = __webpack_public_path__ + "img/white-heart.c8e5c3d6.svg";